module.exports = __webpack_public_path__ + "img/accountxc_icon_logo.4456a22c.png";